import IngredientEdit from './IngredientEdit'

export default IngredientEdit
